import { makeAutoObservable } from 'mobx';

export interface ShowWorkMeeting{
    id:string;
    name:string;
    platform:string;
    information:string;
}

export interface HomeData{

    waitForProcessDemandCount : number;
    inProgressProjectCount:number;
    waitForDeliverTaskCount: number;
    waitForFixBugCount:number;
    thisWeekMeetings : ShowWorkMeeting[];
    nextWeekMeetings : ShowWorkMeeting[];

}

export class Model{
    homeData: HomeData | null = null;
    homeLoadError: string | null = null;
    constructor() {
        makeAutoObservable(this);
    }
}

export const model = new Model();